import { jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { forwardRef } from "react";
const TuneIconInner = (props, ref) => {
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      ...props,
      ref,
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          fill: "currentColor",
          height: "48",
          stroke: "currentColor",
          viewBox: "0 -960 960 960",
          width: "48",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ jsx("path", { d: "M440.463-130.001V-339.23h45.383V-257h344.153v45.384H485.846v81.615h-45.383Zm-310.462-81.615V-257h225.075v45.384H130.001Zm179.692-164.077v-81.615H130.001v-45.384h179.692v-82.846h45.383v209.845h-45.383Zm130.77-81.615v-45.384h389.536v45.384H440.463Zm164.461-163.846v-208.845h45.383v81.615h179.692V-703H650.307v81.846h-45.383ZM130.001-703v-45.384h389.536V-703H130.001Z" })
        }
      )
    }
  );
};
const TuneIcon = forwardRef(TuneIconInner);
export {
  TuneIcon
};
